import { createElement } from "@max/max";
import View from "@hfe/max-view";
import Image from "@hfe/max-image";
import Text from "@hfe/max-text";
import './index.scss';
export default function Avatar(props) {
    const { avatar, badge } = props;
    return badge ? <View className="team-info-captain">
    <View style={{
        borderRadius: '80rpx',
        overflow: 'hidden',
        borderWidth: '1rpx',
        borderColor: 'rgba(255, 255, 255, 0.6)'
    }}>
      <Image source={{
        uri: avatar
    }} style={{
        width: '80rpx',
        height: '80rpx'
    }} resizeMode='cover'/>
    </View>
    <View x-if={badge} className="team-info-captain-badge">
      <Text className="team-info-captain-text">{badge}</Text>
    </View>
  </View> : <View style={{
        height: '80rpx',
        width: '80rpx',
        borderRadius: '80rpx',
        overflow: 'hidden',
        borderWidth: '1rpx',
        borderColor: 'rgba(255, 255, 255, 0.6)',
        marginRight: '33rpx'
    }}>
      <Image source={{
        uri: avatar
    }} style={{
        width: '80rpx',
        height: '80rpx'
    }} resizeMode='cover'/>
    </View>;
}
